async function fetchDados(mesSelecionado) {

    let res = await getDados();
    let dados = formataMetas(res);
    dados = calculaDados(dados)
    dados = calculaTotalDR(dados)
    let mesAMes = {...dados};
    let acumulado = calculaAcumuladoMetas(dados, mesSelecionado);

    return { dados: mesAMes, acumulado };

}

async function getDados() {
    let dados = await fetch(`${process.env.REACT_APP_API_URL}/consulta?tipo=metas`);
    dados = await dados.json();
    return dados.dados;
}

function formataMetas(metas) {
    metas = [...metas]
    metas.forEach((meta, index) => {
        let ano = meta.metasMensais.mes.map((mes, i) => {
            return {
                mes: mes,
                numTurmas: meta.metasMensais["numTurmas"][i],
                numAlunosTurmas: meta.metasMensais["numAlunosTurmas"][i],
                cargaHoraria: meta.metasMensais["cargaHoraria"][i],
                numMatriculasResiduais: meta.metasMensais["numMatriculasResiduais"][i],
                numMatriculasNovas: meta.metasMensais["numMatriculasNovas"][i],
                numTotalMatriculas: meta.metasMensais["numTotalMatriculas"][i],
                horaAluno: meta.metasMensais["horaAluno"][i],
                cargaHorariaTurmaAno: meta.metasMensais["cargaHorariaTurmaAno"][i],
                necessidadeDocente8H: meta.metasMensais["necessidadeDocente8H"][i],
                necessidadeDocente7H: meta.metasMensais["necessidadeDocente7H"][i]
            }
        });
        metas[index].metasMensais = ano;
    });
    return metas;
}

function calculaDados(data) {

    let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    let mesesSIgla = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
    let tipoFinanciamento = ["Pago", "Gratuidade Regimental", "Gratuidade Não-Regimental"]

    let tudo = {}

    meses.map((mes, unidadeIndice) => {

        let mesArr = []

        let porUnidade = groupBy(data, "unidade");

        Object.keys(porUnidade).map((unidade, i) => {
            if (unidade === "") return;
            let novoObj = {}
            novoObj["unidade"] = unidade;
            novoObj["modalidades"] = {}
            let porModalidade = groupBy(porUnidade[unidade], "modalidade");

            Object.keys(porModalidade).map((modalidade, j) => {

                let objModalidades = {
                    matricula_regimental: 0,
                    matricula_nao_regimental: 0,
                    matricula_pago: 0,
                    hora_regimental: 0,
                    hora_nao_regimental: 0,
                    hora_pago: 0
                }


                let pago = porModalidade[modalidade].filter((filter) => filter.tipo === "Pago");
                let regimental = porModalidade[modalidade].filter((filter) => filter.tipo === "Gratuidade Regimental");
                let nao_regimental = porModalidade[modalidade].filter((filter) => filter.tipo === "Gratuidade Não-Regimental");

                if (pago.length > 0) {
                    objModalidades["matricula_pago"] = pago.reduce((acc, atual) => { 
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["numTotalMatriculas"] + acc
                        else return acc
                    }, 0);
                    objModalidades["hora_pago"] = pago.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["horaAluno"] + acc
                        else return acc
                    }, 0);
                }

                if (regimental.length > 0) {
                    objModalidades["matricula_regimental"] = regimental.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["numTotalMatriculas"] + acc
                        else return acc
                    }, 0);
                    objModalidades["hora_regimental"] = regimental.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["horaAluno"] + acc
                        else return acc
                    }, 0);
                }

                if (nao_regimental.length > 0) {
                    objModalidades["matricula_nao_regimental"] = nao_regimental.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["numTotalMatriculas"] + acc
                        else return acc
                    }, 0);
                    objModalidades["hora_nao_regimental"] = nao_regimental.reduce((acc, atual) => {
                        if (atual["metasMensais"][unidadeIndice]) return atual["metasMensais"][unidadeIndice]["horaAluno"] + acc
                        else return acc
                    }, 0);
                }

                novoObj["modalidades"][modalidade] = objModalidades


            })
            mesArr.push(novoObj)
        })

        tudo[mes] = mesArr
    });

    return tudo

}

function calculaTotalDR(dados) {

    if(dados) {

        Object.keys(dados).map(mes => {
            
            let dr = {
                unidade: "DR",
                modalidades: {}
            };

            (dados[mes] || []).map((unidade) => {
                
                Object.keys(unidade.modalidades).map((modalidade) => {

                    let valorModalidade = unidade.modalidades[modalidade];

                    if(!dr.modalidades.hasOwnProperty(modalidade)) {
                        dr.modalidades[modalidade] = { ...valorModalidade };
                    }
                    else {
                        Object.keys(valorModalidade).map((valor) => {
                            dr.modalidades[modalidade][valor] += valorModalidade[valor]
                        });
                    }

                });
            
            });

            dados[mes].push(dr);

        });
    }
    
    return dados;

}

function calculaAcumuladoMetas(dados, mesSelecionado){
    
    dados = { ...dados }
    
    let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    meses = meses.slice(0, meses.indexOf(mesSelecionado) + 1);

    let acumulado = { };
    acumulado[mesSelecionado] = [];
    
    if(dados.hasOwnProperty(mesSelecionado)) {

        meses.map((mes, i) => {

            dados[mes].map((unidade, j) => {

                let ind = acumulado[mesSelecionado].findIndex(uni => uni.unidade === unidade.unidade);
                
                if(ind < 0) {
                    acumulado[mesSelecionado].push(unidade);
                }

                else {
                    Object.keys(unidade.modalidades).map(modalidade => {

                        Object.keys(unidade.modalidades[modalidade]).map(valor => {
                            acumulado[mesSelecionado][ind]["modalidades"][modalidade][valor]  += unidade.modalidades[modalidade][valor]
                        });
                        
                    });
                }

            });
        });
    
    }
    
    return acumulado;
}

function groupBy (objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}

export default { fetchDados }